import React, { useContext } from 'react'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button'
import BharathamLogo from 'assets/images/BharathamLogo.png'
import {
  MainContainer,
  LeftContainer,
  Logo,
  RightContainer,
  Wrapper,
  Content,
  Heading,
  Title,
  SubTitle,
  CheckboxWrapper,
  ButtonContainer,
  HelpText,
  FormWrapper,
  LogoWrapper,
} from 'styles/Feedback'
import { Controller, useForm } from 'react-hook-form'
import { TextField } from '@mui/material'
import usePost from 'hooks/usePost'
import { toast_actions, toast_types } from 'components/shared/toast/utils/toast'
import { ToastContext } from 'context/toastContext'
import { Link } from 'react-router-dom'

const Feedback = () => {
  const { mutateAsync } = usePost()
  const { control, handleSubmit, reset, watch } = useForm()
  const dispatch = useContext(ToastContext)
  const currentUrl = window.location.href
  const url = currentUrl
  const parts = url.split('/')
  const orderId = parts[parts.length - 1]

  // Watch the radio inputs
  const visuallyAppealing = watch('visuallyAppealing')

  // Check if at least one radio button has been selected
  const isAnyRadioSelected = visuallyAppealing

  const onSubmit = async (data) => {
    const payload = {
      message: data.recommendations,
      websiteDesign: data.visuallyAppealing,
    }
    try {
      const res = await mutateAsync({
        url: `clientApis/v2/feedback/${orderId}`,
        method: 'POST',
        payload: payload,
      })
      if (res) {
        dispatch({
          type: toast_actions.ADD_TOAST,
          payload: {
            id: Math.floor(Math.random() * 100),
            type: toast_types.success,
            message: res?.message,
          },
        })
      }
    } catch (error) {
      dispatch({
        type: toast_actions.ADD_TOAST,
        payload: {
          id: Math.floor(Math.random() * 100),
          type: toast_types.error,
          message: error?.response?.data?.message,
        },
      })
    }

    reset()
  }

  return (
    <MainContainer>
      <LeftContainer></LeftContainer>
      <RightContainer>
        <Wrapper>
          <LogoWrapper>
            {' '}
            <Link to="/">
              <Logo src={BharathamLogo} alt="" />
            </Link>
          </LogoWrapper>

          <FormWrapper onSubmit={handleSubmit(onSubmit)}>
            <Content>
              <Heading>Hey ,</Heading>
              <SubTitle>We fulfilled your order from our store and would love to get your feedback.</SubTitle>
            </Content>
            <Content>
              <Title>1. Are you satisfied with the overall buying experience?</Title>
              <CheckboxWrapper>
                <Controller
                  name="visuallyAppealing"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioGroup row {...field}>
                      <FormControlLabel value={true} control={<Radio />} label="Yes" />
                      <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>
                  )}
                />
              </CheckboxWrapper>
            </Content>
            <Content>
              <Title>2. What can we do to make your experience more delightful?</Title>
              <Controller
                name="recommendations"
                control={control}
                defaultValue=""
                render={({ field }) => <TextField {...field} rows={3} multiline variant="outlined" fullWidth />}
              />
            </Content>
            <ButtonContainer>
              <Button variant="contained" type="submit" disabled={!isAnyRadioSelected}>
                Submit Review
              </Button>
            </ButtonContainer>
          </FormWrapper>
          <HelpText>
            Need Help? Ask at <span>support@bharath.am</span> or visit our <span>help center</span>
          </HelpText>
        </Wrapper>
      </RightContainer>
    </MainContainer>
  )
}

export default Feedback
